<template>
  <v-select
    v-model="municipioSolucao.municipioSolucao"
    item-text="nome"
    item-value="municipioSolucaoId"
    :items="allSolutions"
    label="Solução"
    placeholder="Solução"
    clearable
    :return-object="true"
    @change="change"
  >
    <template slot="no-data"> Nenhuma Solução retornada </template>
  </v-select>
</template>

<script>
export default {
  name: "AppCitySolutionCombobox",
  props: ["filter", "allSolutions", "municipioSolucao"],
  methods: {
    change(value) {
      if (value) this.municipioSolucao.municipioSolucao = value;
      else this.municipioSolucao.municipioSolucao = {};

      this.$emit("changeSolution");
    },
  },
};
</script>
